import spotlightBeam from "@/assets/spotlight-beam.jpg";

/*
 * TheatricalSpotlight — real photographic stage-light beam (not CSS-drawn).
 *
 * Rendered fixed on the whole viewport, centered horizontally, behind app
 * content. The source photo is already near-black outside the beam, so it
 * blends directly into the app's black background with no extra vignette.
 */
export default function TheatricalSpotlight() {
  return (
    <div
      className="theatrical-spotlight-global pointer-events-none fixed inset-0 overflow-hidden"
      style={{
        zIndex: 0,
        backgroundImage: `url(${spotlightBeam})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
      }}
      aria-hidden="true"
      data-testid="theatrical-spotlight"
    />
  );
}
